import React from "react";

const PrivacyPolicy = () => {
  return (
    <section className="w-full bg-gradient-radial py-12 lg:py-16">
      <div className="container mx-auto px-4 lg:px-12">
        {/* Heading */}
        <div className="text-center my-10">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold font-inter !text-white">
            Privacy Policy
          </h1>
          <p className="mt-2 text-base sm:text-lg lg:text-xl font-medium font-inter text-white/70">
            Your privacy matters to us at FWPI
          </p>
        </div>

        {/* Content Card */}
        <div className="bg-[#181B23] rounded-[24px] backdrop-blur-lg border border-slate-950/10 px-5 py-8 sm:p-10 lg:p-12 text-white/80 font-inter space-y-8 leading-relaxed">
          
          <p>
            At <span className="text-white font-semibold">Fitness & Wellness Professionals of India (FWPI)</span>, 
            accessible from <span className="text-white">fwpiindia.com</span>, we are committed to protecting your privacy. 
            This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website 
            or engage with our services.
          </p>

          {/* Section */}
          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              1. Information We Collect
            </h2>
            <p>
              We may collect personal information such as your name, email address, phone number, professional details, 
              and any other information you voluntarily provide through forms, registrations, or inquiries on our website.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              2. How We Use Your Information
            </h2>
            <p>
              FWPI uses the collected information to:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Respond to your queries and provide support</li>
              <li>Process memberships, accreditations, and certifications</li>
              <li>Improve our services and website experience</li>
              <li>Send important updates, notifications, or promotional communication</li>
              <li>Ensure compliance with legal and regulatory requirements</li>
            </ul>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              3. Sharing of Information
            </h2>
            <p>
              We do not sell, trade, or rent your personal information to third parties. 
              Your data may only be shared with trusted partners or authorities when required 
              for service delivery, legal compliance, or protection of FWPI’s rights.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              4. Data Security
            </h2>
            <p>
              We implement appropriate technical and organizational measures to safeguard your personal information. 
              While we strive to protect your data, no method of transmission over the internet is 100% secure.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              5. Cookies & Tracking Technologies
            </h2>
            <p>
              FWPI may use cookies and similar technologies to enhance user experience, analyze usage patterns, 
              and improve our website. You can choose to disable cookies through your browser settings.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              6. Third-Party Links
            </h2>
            <p>
              Our website may contain links to external sites. FWPI is not responsible for the privacy practices 
              or content of such third-party websites.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              7. Your Rights
            </h2>
            <p>
              You have the right to access, update, or request deletion of your personal data. 
              You may also opt out of promotional communications at any time.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              8. Updates to This Policy
            </h2>
            <p>
              FWPI reserves the right to update this Privacy Policy from time to time. 
              Any changes will be posted on this page with an updated effective date.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-white mb-2">
              9. Contact Us
            </h2>
            <p>
              If you have any questions or concerns about this Privacy Policy, please contact us:
            </p>
            <ul className="mt-2 space-y-1">
              <li>
                🌐 Website: <span className="text-white">fwpiindia.com</span>
              </li>
              <li>
                📧 Email: <a href="mailto:support@fwpiindia.com" className="text-white hover:!text-gray-400">support@fwpiindia.com</a>
              </li>
              <li>
                📞 Phone: <a href="tel:9996108446" className="text-white hover:!text-gray-400">+91 9996108446</a>
              </li>
            </ul>
          </div>

          <p className="pt-6 text-center text-white/60 italic">
            Every credible wellness journey begins with FWPI
          </p>
        </div>
      </div>
    </section>
  );
};

export { PrivacyPolicy };
